import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import InputV2 from "kreate-common/modules/kreate-ui/components/InputV2";
import React from "react";
import { MdOutlineCheckCircle } from "react-icons/md";

import ButtonPopoverInfo from "../../components/ButtonPopoverInfo";
import InlineErrorViewer from "../../components/InlineErrorViewer";

import { useFieldMintPrice } from "./hooks";
import styles from "./index.module.scss";

import { ADA_SYMBOL } from "@/modules/common-utils/unicode";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  api: ReturnType<typeof useFieldMintPrice>;
};

export default function FieldMintPrice({ className, style, api }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Col gap="8px">
        <InputV2
          size="xl"
          label="Minting Price (per Edition)"
          value={api.text}
          onChange={(value) => api.setText(value)}
          onBlur={() => api.validateAfterEditing()}
          placeholder="ADA"
          autoComplete="off"
          color={api.error ? "error" : "normal"}
          slotRight={
            <Flex.Row
              padding="0 16px"
              alignItems="center"
              justifyContent="center"
              gap="8px"
            >
              <div className={styles.adaSymbol}>{ADA_SYMBOL}</div>
              {api.error === null ? (
                <MdOutlineCheckCircle size="24px" color="#006E46" />
              ) : null}
              <ButtonPopoverInfo content="The price Collectors pay for each Edition they mint" />
            </Flex.Row>
          }
        />
        {api.error ? <InlineErrorViewer content={api.error.message} /> : null}
      </Flex.Col>
    </div>
  );
}
